import React from "react";
import ReleaseUpdatesPage from "../../components/release-notes/ReleaseUpdatesPage";
import NewLayout from "../../layout/dashboard/NewLayout";

const PlatformUpdatesPage = () => {
  return (
    <NewLayout>
      <ReleaseUpdatesPage />
    </NewLayout>
  );
};

export default PlatformUpdatesPage;
